import { render, staticRenderFns } from "./ActiveInitialTermDashboard.vue?vue&type=template&id=1660d484&scoped=true&"
import script from "./ActiveInitialTermDashboard.vue?vue&type=script&lang=ts&"
export * from "./ActiveInitialTermDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660d484",
  null
  
)

export default component.exports